import { View } from 'react-native'

import * as Comp from './footer.styles'

import { Button } from '~/components/button'

type OptionMenuFooterProps = {
  controls: {
    type: 'cancel' | 'confirm'
    label: string
    handler(): void
  }[]
  testID?: string
}

export function Footer({ controls, testID }: OptionMenuFooterProps) {
  if (!controls) {
    throw new Error('Controls cannot be undefined.')
  }

  return (
    <Comp.Container testID={testID}>
      {controls.slice(0, 2).map((control, idx) => {
        const btnVariant =
          control.type === 'confirm' ? 'brand-primary' : 'neutral-tertiary'

        return (
          <View style={{ flex: 1 }} key={String(idx)}>
            <Button.Root
              variant={btnVariant}
              onPress={control.handler}
              size="lg"
            >
              <Button.Label>{control.label}</Button.Label>
            </Button.Root>
          </View>
        )
      })}
    </Comp.Container>
  )
}
